import moment from "moment";
import React, {useState} from "react";
import cn from "classnames";
import {useForm} from "react-hook-form";
import Modal from "../common/Modal";
import * as api from "../../api/IrsClient";
import MONTH from "../../resources/data/month.json";
import { BASE_10 } from "../../constant";

const UploadBotReport = () => {
  const [selectedFiles, setSelectedFiles] = useState([]);
  const { register, handleSubmit, errors, getValues, reset } = useForm({
    mode: "onChange",
  });
  const [isLoading, setLoading] = useState(false);
  const [isConfirmationShown, setIsConfirmationShown] = useState(false);
  const [isSuccessfulShown, setIsSuccessfulShown] = useState(false);
  const [isFailShown, setIsFailShown] = useState(false);
  const [isInvalidaExtShown, setInvalidaExtShown] = useState(false);

  function onSubmit() {
    setIsConfirmationShown(true);
  }

  async function upload() {
    try {
      setIsConfirmationShown(false);
      setLoading(true);
      const values = getValues();
      const data = new FormData();
      data.append("file", selectedFiles[0]);
      data.append("date", values.year + values.month);
      const {
        data: {
          status: { code },
        },
      } = await api.uploadBotReport(data);
      setLoading(false);
      if (code !== "0") {
        setIsFailShown(true);
        return;
      }
      setIsSuccessfulShown(true);
      setSelectedFiles([]);
      reset();
    } catch (error) {
      console.log("Error while call upload()", error);
    }
  }

  function handleChangeFile(e) {
    e.persist();
    const files = e.target.files;
    if (files.length) {
      if (files[0].type !== "text/plain") {
        setInvalidaExtShown(true);
        return false;
      }
    }

    setSelectedFiles([...e.target.files]);
  }

  function handleClickFile(e) {
    e.persist();
    e.target.value = "";
  }

  function removeFile(filename) {
    setSelectedFiles((prev) => prev.filter((x) => x.name !== filename));
  }

  function renderDescription() {
    const values = getValues();
    if (!values.month || !values.year) return "";
    const month = MONTH.find((x) => values.month === x.value).name;
    const year = values.year;
    return `You are about to upload the report to\n Month: ${month}, Year: ${year}`;
  }

  const currentYear = parseInt(moment().format("YYYY"), BASE_10);

  return (
    <>
      <div className="container bot-report">
        <div className="card card-secondary">
          <div className="card-header">
            <h5>Upload BOT Report</h5>
          </div>
          <div className="file-list">
            {selectedFiles.map((x) => (
              <div
                key={x.lastModified}
                className="card card-shadow p-4 file-info"
              >
                <div className="file-info-header">
                  <div className="file-info-title">File name</div>
                  <div
                    className="file-info-delete-button"
                    onClick={() => removeFile(x.name)}
                  >
                    Delete File
                  </div>
                </div>
                <div className="file-info-filename">{x.name}</div>
                <div className="file-info-title">
                  Choose month and year to upload
                </div>
                <form onSubmit={handleSubmit(onSubmit)} data-testid="bot-upload-form">
                  <div className="row">
                    <div className="col-sm-4">
                      <div
                        className={cn("form-group row", {
                          "form-group-error": errors?.month,
                        })}
                      >
                        <label className="col-form-label col-sm-4 text-lg-right">
                          Month
                        </label>
                        <div className="col-sm-8 p-0">
                          <select data-testid="upload-month"
                            className="form-control"
                            name="month"
                            {...register('month' ,{ required: true })}
                          >
                            <option value="">Select...</option>
                            {MONTH.map((x) => (
                              <option key={x.value} value={x.value}>
                                {x.name}
                              </option>
                            ))}
                          </select>
                          {errors?.month?.type === "required" && (
                            <span className="input-error-message">
                              Please select month
                            </span>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="col-sm-4">
                      <div
                        className={cn("form-group row", {
                          "form-group-error": errors?.year,
                        })}
                      >
                        <label className="col-form-label col-sm-4 text-lg-right">
                          Year
                        </label>
                        <div className="col-sm-8 p-0">
                          <select data-testid="upload-year"
                            className="form-control"
                            name="year"
                            {...register('year' ,{ required: true })}
                          >
                            <option value="">Select...</option>
                            {Array.from(Array(currentYear - 2020)).map(
                              (_, i) => {
                                const year = currentYear - i;
                                return (
                                  <option key={year} value={year}>
                                    {year}
                                  </option>
                                );
                              }
                            )}
                          </select>
                          {errors?.year?.type === "required" && (
                            <span className="input-error-message">
                              Please select year
                            </span>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="col-sm-4 text-lg-right">
                      <button className="btn btn-success">
                        Upload
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            ))}
          </div>
          <div className="browse-file">
            <input
              id="upload-file"
              data-testid="upload-file"
              className="upload-file"
              type="file"
              name="file"
              accept="text/plain"
              onChange={handleChangeFile}
              onClick={handleClickFile}
            />
            <label className="btn btn-dashed" htmlFor="upload-file">
              Browse File
            </label>
          </div>
        </div>
      </div>

      <Modal
        loading={isLoading}
        message="Confirm upload"
        description={renderDescription()}
        isOpen={isConfirmationShown}
        onCancel={() => setIsConfirmationShown(false)}
        onOk={upload}
        textOk="Confirm"
      />
      <Modal
        loading={isLoading}
        message="Upload success"
        isOpen={isSuccessfulShown}
        onCancel={null}
        onOk={() => setIsSuccessfulShown(false)}
        textOk="Close"
      />
      <Modal
        loading={isLoading}
        message="Upload fail"
        isOpen={isFailShown}
        onCancel={null}
        onOk={() => setIsFailShown(false)}
        textOk="Try Again"
      />
      <Modal
        loading={isLoading}
        message="Upload fail"
        isOpen={isInvalidaExtShown}
        description="Allow to upload only .txt file. Please try again."
        onCancel={null}
        onOk={() => setInvalidaExtShown(false)}
        textOk="Try Again"
      />
    </>
  );
};

export default UploadBotReport;
